import React from 'react';
import { Grid } from '@mui/material';
import appConfig from '../../../config/appConfig';
import ForgotPasswordEmailForm from '../components/ForgotPasswordEmailForm';
import { useLocation, useSearchParams } from 'react-router-dom';
import ForgotPasswordUpdateForm from '../components/ForgotPasswordUpdateForm';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { authPageGridSx } from '../../../styles/authPageLayout';

const ForgotPasswordPage = () => {
  const { forgotPassword: fp } = useTranslatedMessages();
  useDocumentTitle(fp.page_title ?? 'Reset Password');
  const location = useLocation();
  const [searchParams] = useSearchParams();

  let state = location.state || {
    email: searchParams.get('email'),
    stage: searchParams.get('stage'),
  };

  const getComponent = () => {
    if (state?.email) {
      return <ForgotPasswordUpdateForm email={state.email} />;
    }
    return <ForgotPasswordEmailForm />;
  };
  return (
    <Grid container sx={authPageGridSx}>
      <Grid
        size={{ xs: 0, lg: 7, xl: 6 }}
        sx={{
          display: { sm: 'none', lg: 'flex' },
        }}
      >
        <img
          src={appConfig.brandBackgroundImagePath}
          alt="signup background"
          width="100%"
          style={{ display: 'flex' }}
        />
      </Grid>
      <Grid size={{ xs: 1, sm: 2, md: 3, lg: 1, xl: 2 }} />
      <Grid size={{ xs: 10, sm: 8, md: 6, lg: 3, xl: 3 }}>{getComponent()}</Grid>
      <Grid size={{ xs: 1, sm: 2, md: 3, lg: 1, xl: 1 }} />
    </Grid>
  );
};

export default ForgotPasswordPage;
